<template>
  <div>
    <Spinner v-if="loading" />
    <StaticDataTable class="static-table-list" v-show="!loading && !loadingError">
      <template v-slot:header>
        <tr>
          <th width="40%">Price Group</th>
          <th width="60%">Default Edgework</th>
        </tr>
      </template>
      <template v-slot:body>
        <tr v-for="priceGroup in priceGroupList" :key="priceGroup.id">
          <td class="font-weight-bold">
            {{priceGroup.name}}
          </td>
          <td v-if="!editing">
            <span v-if="edgeworkForPriceGroup(priceGroup.id)">
              <span>{{edgeworkNameForId(edgeworkForPriceGroup(priceGroup.id))}}</span>
            </span>
            
            <span v-if="!edgeworkForPriceGroup(priceGroup.id)" class="font-italic text-muted">
              <span v-if="!defaultEdgeworkForPriceGroup(priceGroup.id)">None</span>
              <span v-else>Default: {{edgeworkNameForId(defaultEdgeworkForPriceGroup(priceGroup.id))}}</span>
            </span>
          </td>

          <td v-if="editing">
            <FormSelect 
              :options="edgeworkLookup" 
              :value="edgeworkForPriceGroup(priceGroup.id)"
              @input="updateEdgeworkForPriceGroup(priceGroup.id, $event)"
            />
          </td>
        </tr>
      </template>
      <template v-slot:empty v-if="priceGroupList.length == 0">
        No price groups found        
      </template>
    </StaticDataTable>
    <span class="text-danger" v-if="loadingError">{{loadingError}}</span>
  </div>
</template>


<script>
import _ from 'lodash'
import formMixin from '@/mixins/form'

export default {
  name: 'DefaultEdgeworkLinkEditor',
  model: {
    event: 'update'
  },
  mixins: [formMixin],
  props: {
    editing: Boolean,
    stockId: Number,
    value: Array
  },
  data() {
    return {
      loading: false,
      loadingError: '',
      priceGroupList: [],
      edgeworkConfigList: [],
      edgeworkDefaultLinksList: [],
      
      edgeworkLinkList: _.cloneDeep(this.$props.value || [])
    }
  },
  computed: {
    edgeworkLookup() {
      return _.concat(
        [ { name: 'None', value: null } ],
        this.edgeworkConfigList.map(edgework => {
          return {
            value: edgework.id,
            name: edgework.name
          }
        })
      )
    },
  },
  watch: {
    value: {
      deep: true,
      handler: function() {
        this.$data.edgeworkLinkList = _.cloneDeep(this.$props.value)
      }
    }
  },
  mounted() {
    this.requestData()
  },
  methods: {
    reloadData() {
      this.requestData()
    },
    requestData() {
      this.loading = true
      this.loadingError = ''

      Promise.all([
        this.$apiService.pricingService.getStockPriceGroupList(),
        this.$apiService.orderEditorService.getOrderEditorEdgeworkList(),
        this.$apiService.orderEditorService.getOrderEditorDefaultEdgeworkList(),
      ])
      .then(results => {
        this.priceGroupList = results[0].data
        this.edgeworkConfigList = results[1].data
        this.edgeworkDefaultLinksList = results[2].data        
      })
      .catch(err => {
        this.loadingError = 'Failed to load data'
      })
      .finally(() => {
        this.loading = false
      })
    },
    defaultEdgeworkForPriceGroup(priceGroupId) {
      let linkInfo = this.edgeworkDefaultLinksList.find(link => link.stockPriceGroupId == priceGroupId)
      if(linkInfo)
        return linkInfo.orderEditorEdgeworkConfigId
      return null
    },
    edgeworkNameForId(edgeworkConfigId) {
      let edgeworkInfo = this.edgeworkConfigList.find(edgework => edgework.id == edgeworkConfigId)
      if(edgeworkInfo)
        return edgeworkInfo.name
      return ''
    },
    edgeworkForPriceGroup(priceGroupId) {
      let linkInfo = this.edgeworkLinkList.find(link => link.stockPriceGroupId == priceGroupId)
      if(linkInfo)
        return linkInfo.orderEditorEdgeworkConfigId
      return null
    },
    updateEdgeworkForPriceGroup(priceGroupId, edgeworkConfigId) {
      let linkInfo = this.edgeworkLinkList.find(link => link.stockPriceGroupId == priceGroupId)
      if(linkInfo) {
        linkInfo.orderEditorEdgeworkConfigId = edgeworkConfigId ? parseInt(edgeworkConfigId) : null
      } else {
        this.edgeworkLinkList.push({
          stockPriceGroupId: priceGroupId,
          orderEditorEdgeworkConfigId: edgeworkConfigId ? parseInt(edgeworkConfigId) : null
        })        
      }

      // Remove 'none' values
      this.edgeworkLinkList = this.edgeworkLinkList.filter(link => link.orderEditorEdgeworkConfigId != null)

      this.$emit('update', this.edgeworkLinkList)
    }

  }


}
</script>